import { Component, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-print-page",
  templateUrl: "./print-page.component.html",
  styleUrls: ["./print-page.component.css"],
  encapsulation: ViewEncapsulation.None
})
export class PrintPageComponent {
  whichPage: any;

  constructor(private route: ActivatedRoute) {
    this.whichPage = this.route.snapshot.paramMap.get("id");
  }

  printPageWithDiffrentCss() {
    console.log("kk-------------------------->");
    window.print();
  }
}
